<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="formData.payload"
              responsive
              sticky-header
              show-empty
              borderless
              class="default-static-table m-0"
            >
              <template #cell(no)="data">
                <span>{{ data.item.transaction_id || '-' }}</span>
              </template>
              <template #cell(date)="data">
                <span>{{ resolveDate(data.item.tx_time) || '-' }}</span>
              </template>
              <template #cell(time)="data">
                <span>{{ resolveTime(data.item.tx_time) || '-' }}</span>
              </template>
              <template #cell(point)="data">
                <span>{{ data.item.point || '-' }}</span>
              </template>
              <template #cell(point_src)="data">
                <span>{{ data.item.reference || '-' }}</span>
              </template>

              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
    </b-row>
    <!-- <b-row class="px-1">
      <b-col
        cols="12"
        class="my-1"
      >
        <pagination-with-reorder
          entity-editable
          :pagination="pagination"
          @entityChange="onFilterEntity"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import usePointHistory from '../hooks/usePointHistory'

export default {
  components: { BTable, PaginationWithReorder },

  setup() {
    const {
      formData,
      fields,
      loading,
      pagination,
      resolveDate,
      resolveTime,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
    } = usePointHistory()

    return {
      formData,
      fields,
      loading,
      pagination,
      resolveDate,
      resolveTime,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/data-management/point-history.css';
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
